import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Tab, Tabs, Nav, Accordion } from 'react-bootstrap';
import { FCI_CF_ACCESS_ROLE, FCI_IF_ACCESS_ROLE } from '../../../config/IFConstant';
import TextareaAutosize from 'react-textarea-autosize';

const AddCustomerDetail = (props) => {
  console.log(props);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'pb_mobile' || name === 'cb_mobile') {
        if (!/^\d*$/.test(value) || value.length > 10) return;
      }

    props.setCustomerDetails((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  let disableCond = props.customerDetails.is_co_borrower_enable === false ? (props.customerDetails?.pb_full_name && props.customerDetails?.pb_mobile) : (props.customerDetails?.pb_full_name && props.customerDetails?.pb_mobile && props.customerDetails?.cb_full_name && props.customerDetails?.cb_mobile)
  
const hasIFRole = props?.loginData?.role_id?.includes(FCI_IF_ACCESS_ROLE);
const hasCFRole = props?.loginData?.role_id?.includes(FCI_CF_ACCESS_ROLE);
const disableIF = hasCFRole && !hasIFRole;
const disableCF = hasIFRole && !hasCFRole;
  return (
    <div className="image-form-outer">
      <div className="form-tab-right-panel">
        <div className="lead-detail-from-outer">
          <div className="lead-form-heading">
            <h2>Add Customer Details</h2>
            <span className="add-cus-sub-heading">Lead Type</span>
          </div>

          <div className="lead-form-filed">
            <div className="add-cutomer-tabs">
              <Tab.Container id="left-tabs-example" defaultActiveKey={disableIF ? "second" : "first"}>
                <Nav variant="pills" className="flex-column p-lg-b">
                  <div className="tab-list d-flex">
                    <Nav.Item>
                      <Nav.Link eventKey="first" onClick={()=> props.setCustomerDetails((prev) => ({...prev,lead_type:'if'}))} disabled={disableIF}>
                        Inventory Finance
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second" onClick={()=> props.setCustomerDetails((prev) => ({...prev,lead_type:'cf'}))} disabled={disableCF}>
                        Consumer Finance
                      </Nav.Link>
                    </Nav.Item>
                  </div>
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <div className="row p-lg-t">
                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input
                            id="pb_full_name"
                            type="text"
                            placeholder=""
                            name="pb_full_name"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.pb_full_name}
                            onChange={handleChange}
                          />
                          <label
                            data-label="PB Full Name *"
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>

                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input
                            id="pb_mobile"
                            type="text"
                            placeholder=""
                            name="pb_mobile"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.pb_mobile}
                            onChange={handleChange}
                          />
                          <label
                            data-label="PB Mobile No. *"
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>

                      <div className="col-md-12">
                        <div className="co-borrower-heading m-lg-b">
                          <span>Add Co-Borrower</span>
                          <div className="custom-control custom-checkbox">
                            <input
                              id="is_co_borrower_enable"
                              type="checkbox"
                              className="custom-control-input"
                              name="is_co_borrower_enable"
                              checked={props.customerDetails.is_co_borrower_enable}
                              onChange={handleChange}
                            />
                            <label className="custom-control-label"></label>
                          </div>
                        </div>
                      </div>

                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input    
                            id="cb_full_name"
                            type="text"
                            placeholder=" "
                            name="cb_full_name"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.cb_full_name}
                            onChange={handleChange}
                            disabled={!props.customerDetails?.is_co_borrower_enable}
                          />
                          <label
                            data-label="CB Full Name"
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>

                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input
                            id="cb_mobile"
                            type="text"
                            placeholder=" "
                            name="cb_mobile"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.cb_mobile}
                            onChange={handleChange}
                            disabled={!props.customerDetails?.is_co_borrower_enable}
                          />
                          <label
                            data-label="CB Mobile No."
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>
                    </div>

                    <div className="btn-save-remarks m-lg-t">
                      <button type="button" className="btn-primary" disabled={!disableCond} onClick={()=> props.setActiveStep(2)}>
                        Continue
                      </button>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="second">
                    <div className="row p-lg-t">
                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input
                            id="pb_full_name"
                            type="text"
                            placeholder=""
                            name="pb_full_name"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.pb_full_name}
                            onChange={handleChange}
                          />
                          <label
                            data-label="PB Full Name *"
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>

                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input
                            id="pb_mobile"
                            type="text"
                            placeholder=""
                            name="pb_mobile"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.pb_mobile}
                            onChange={handleChange}
                          />
                          <label
                            data-label="PB Mobile No. *"
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>

                      <div className="col-md-12">
                        <div className="co-borrower-heading m-lg-b">
                          <span>Add Co-Borrower</span>
                          <div className="custom-control custom-checkbox">
                            <input
                              id="is_co_borrower_enable"
                              type="checkbox"
                              className="custom-control-input"
                              name="is_co_borrower_enable"
                              checked={props.customerDetails.is_co_borrower_enable}
                              onChange={handleChange}
                            />
                            <label className="custom-control-label"></label>
                          </div>
                        </div>
                      </div>

                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input    
                            id="cb_full_name"
                            type="text"
                            placeholder=" "
                            name="cb_full_name"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.cb_full_name}
                            onChange={handleChange}
                          />
                          <label
                            data-label="CB Full Name"
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>

                      <fieldset className="form-filed col-md-6">
                        <div className="material">
                          <input
                            id="cb_mobile"
                            type="text"
                            placeholder=" "
                            name="cb_mobile"
                            className="form-input"
                            autoComplete="off"
                            value={props.customerDetails.cb_mobile}
                            onChange={handleChange}
                          />
                          <label
                            data-label="CB Mobile No."
                            className="form-label"
                          ></label>
                        </div>
                      </fieldset>
                    </div>

                    <div className="btn-save-remarks m-lg-t">
                      <button type="button" className="btn-primary" disabled={!disableCond} onClick={()=> props.setActiveStep(2)}>
                        Continue
                      </button>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerDetail;
